<template>
  <div id="rpay"></div>
</template>








<script>
/* eslint-disable */
let Base64 = require("js-base64").Base64;

export default {
  name: "rpay",
  data() {
    return {
      jsApiParameters: "", //微信支付需要的参数
      return_url:"",//支付成功之后前往充值页面
    };
  },
  methods: {

    onBridgeReady() {
      let _this = this;
      var jsApiParameters = _this.jsApiParameters;
      WeixinJSBridge.invoke("getBrandWCPayRequest", jsApiParameters, function(
        res
      ) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 郑重提示：res.err_msg将在用户支付成功后返回 ok，但并不保证它绝对可靠。
          _this.$tool.hiddenLoading();
          setTimeout(function() {
            _this.$tool.tip("支付成功");
            setTimeout(() => {
              window.location.href = _this.return_url;
            }, 1000);
          }, 1000);
        } else if (res.err_msg == "get_brand_wcpay_request:fail") {
          alert("支付失败！");
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          window.location.href = _this.return_url;
        }
      });
    },
    pdWeixinJSBridge() {
      let _this = this;
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            _this.onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", _this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", _this.onBridgeReady);
        }
      } else {
        _this.onBridgeReady();
      }
    },

    /**获取支付数据 */
    get_pay_data() {
      if (this.$tool.isStr(this.$route.query.data)) {
        this.$tool.showLoading();
        let pay_data = Base64.decode(this.$route.query.data);
        let r_url = decodeURI(this.$route.query.returnurl);
        this.jsApiParameters = JSON.parse(pay_data);
        this.return_url = r_url;
        this.pdWeixinJSBridge();
      } else {
        //没有携带参数，弹出提示
        alert("页面错误");
      }
    }
  },
  mounted: function() {
    //获取支付数据
    this.get_pay_data();
  }
};
</script>















<style scoped>
</style>
